import http from "./httpService";
import { apiEndpoint } from "../config.json";
import { objectToQueryString } from "../functions/utils";
export function getReport(params) {
    return http.get(apiEndpoint + "reports" + objectToQueryString(params));
}
